import { useRef, useEffect, useCallback } from 'react';
import { SourceResolver } from '../utils/sourceResolver';
import { SourceResolverOptions } from '../types/sources';

export function useSourceResolver(options?: Partial<SourceResolverOptions>) {
  const resolverRef = useRef<SourceResolver | null>(null);

  if (!resolverRef.current) {
    resolverRef.current = new SourceResolver(options);
  }

  const cleanup = useCallback(() => {
    if (resolverRef.current) {
      resolverRef.current.cleanup();
    }
  }, []);

  useEffect(() => {
    return () => {
      cleanup();
    };
  }, [cleanup]);

  return {
    resolver: resolverRef.current,
    cleanup,
    getBlobUrlCount: () => resolverRef.current?.getBlobUrlCount() ?? 0,
  };
}
